
export default {
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },

  computed: {
    status() {
      if (this.profile.status && this.profile.status[0]) {
        return this.profile.status[0];
      } else if (this.profile?.status?.text) {
        return this.profile.status;
      }
      return null;
    },
  },
};
